import React, { useState } from 'react'
import classNames from 'classnames'
import imageSignIn from '../assets/imageSignIn.svg'
import imageLoginResponsive from '../assets/imageLoginResponsive.svg'
import Logo from '../assets/logo.png'
import ArrowRight from '../assets/ArrowRight.png'
import VisibleEye from '../assets/visibleEye.svg'
import InvisibleEye from '../assets/invisibleEye.svg'
import logoSignup from '../assets/logoMyEasy.svg'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as yup from 'yup'
import ImageSignUp from './signUpContainer/imageSignUp'
import { resetPassword } from 'requests/user'
import ModalReinitialiserPassword from './modalReinitialiserPassword'
import newImageLogin from '../assets/newImageLogin.webp'
import ContainerHome from './containerHome/containerHome'
import LogoConatiner from './signUpContainer/logoContainer'

const MotDePassOublier: React.FC = () => {
  const [visible, setVisible] = useState(false)
  const [visibleConfirmed, setVisibleConfirmed] = useState(false)
  const [isInputClicked, setIsInputClicked] = useState(true)

  const[verifiePassword, setVerifiePassword] = useState(false)
  const[passwordSuccess, setPasswordSuccess] = useState(false)


  const openModalPassword=()=>{
    setVerifiePassword(true)
  }

  const closeModalPassword=()=>{
    setVerifiePassword(false)
  }

  const { token } = useParams()

  const navigate = useNavigate()
  const goBack = () => {
    navigate('/login')
  }

  const initialFormData = {
    newPassword: '',
    confirmedPassword: '',
  }

  const [formData, setFormData] = useState(initialFormData)

  const validationSchema = yup.object({
    newPassword: yup
      .string()
      .required('Ce champ est requis')
      .matches(
        /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z\d\s])[^\s]{8,16}$/,
        'Le mot de passe doit contenir au moins 8 caractères avec au moins 1 lettre, 1 chiffre et 1 caractère spécial.',
      ),

    confirmedPassword: yup
      .string()
      .required('Ce champ est requis')
      .oneOf([yup.ref('newPassword')], 'Les mots de passe ne correspondent pas')
      .matches(
        /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z\d\s])[^\s]{8,16}$/,
        'Le mot de passe doit contenir au moins 8 caractères avec au moins 1 lettre, 1 chiffre et 1 caractère spécial.',
      ),
  })

  const handleSubmit = (values: typeof initialFormData) => {
    const credentials = {
      password: values.newPassword,
      confirmedPassword: values.confirmedPassword,
    }
    setFormData(initialFormData)

    if (formik.isValid) {
      resetPassword(credentials?.password, token).then(async (response: any) => {
        if (response?.success) {
          openModalPassword()
          setPasswordSuccess(true)
        }else{
          openModalPassword()
          setPasswordSuccess(false)
        }
      })
    } else {
      console.log('Nous sommes désolé une erreur est survenue. Merci de réessayer plus tard')
    }
  }

  const formik = useFormik({
    initialValues: initialFormData,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  })

  return (
    <div>
      <div className="flex xs:flex-col sm:gap-y-[27px]">
        <div className="w-[50%] lg:w-[80%] sm:w-[358px] sm:mx-[16px] sm:h-[450px]">
        <LogoConatiner retour={false} image={logoSignup} />

          <div className="mx-[186px] sm:mx-[16px] xl:mx-[90px]">
            <div
              className={classNames(
                'sm:text-[20px] text-[24px] text-[#5754E5] 6xl:text-[18px] text-left sm:font-semibold font-bold mt-[80px] sm:mt-[0px]',
               
              )}
            >
              Réinitialisez votre mot de passe
            </div>
            <form
              className={classNames(
                'grid grid-cols-1 sm:gap-[15px] gap-[30px] sm:mt-[30px]) ',
              
              )}
              onSubmit={formik.handleSubmit}
            >
              <div>
                <div className="relative h-[130px]">
                  <input
                    className="bg-[#F9FAFB] px-[14px] py-4 rounded-xl w-full mt-4 placeholder:text-[#9CA3AF] text-[#5754E5]"
                    name="newPassword"
                    placeholder="Nouveau mot de passe"
                    type={visible ? 'text' : 'password'}
                    value={formik.values.newPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur('newPassword')}
                    // autoComplete='off'
                  />
                  <img
                    src={!visible  ? InvisibleEye : VisibleEye}
                    alt={visibleConfirmed ? 'Afficher le mot de passe' : 'Masquer le mot de passe'}
                    width={20}
                    height={20}
                    className={classNames('absolute right-5 3xl:right-1 top-8 sm:w-5 sm:h-5 cursor-pointer')}
                    onClick={() => setVisible(!visible)}
                  />
                  {formik.errors.newPassword && formik.touched.newPassword && (
                    <div className="text-red-500 text-sm">{formik.errors.newPassword}</div>
                  )}
                </div>
                <div className="text-[13px] text-[#6B7280] mt-1">
                  Le mot de passe doit contenir au moins 8 caractères avec au moins 1 lettre, 1 chiffre et 1 caractère
                  spécial.
                </div>
                <div className="relative h-[120px]">
                  <input
                    className="bg-[#F9FAFB] px-[14px] py-4  rounded-xl w-full mt-4 placeholder:text-[#9CA3AF] text-[#5754E5]"
                    name="confirmedPassword"
                    placeholder="Confirmer le nouveau mot de passe"
                    type={visibleConfirmed ? 'text' : 'password'}
                    value={formik.values.confirmedPassword}
                    onChange={formik.handleChange}
                    // autoComplete='off'
                    onBlur={formik.handleBlur('confirmedPassword')}
                  />
                  <img
                    src={!visibleConfirmed  ? InvisibleEye : VisibleEye}
                    alt={visibleConfirmed ? 'Afficher le mot de passe' : 'Masquer le mot de passe'}
                    width={20}
                    height={20}
                    className={classNames('absolute right-5 3xl:right-1 top-8 sm:w-5 sm:h-5 cursor-pointer')}
                    onClick={() => setVisibleConfirmed(!visibleConfirmed)}
                  />
                  
                  {formik.errors.confirmedPassword && formik.touched.confirmedPassword && (
                    <div className="text-red-500 text-sm">{formik.errors.confirmedPassword}</div>
                  )}
                </div>
              </div>
              <div className="flex justify-center mt-5">
                <button
                  disabled={formik.isSubmitting || !formik.isValid}
                  type="submit"
                  className={` text-white px-[14px] py-4 text-[15px] font-medium rounded-xl w-[80%]
                ${formik.isSubmitting || !formik.isValid ? 'bg-gray-500' : 'bg-[#5754E5]'}
                `}
                >
                  Réinitialiser
                </button>
              </div>
            </form>
          </div>
          <ModalReinitialiserPassword 
            isOpen={verifiePassword} 
            closeModal={closeModalPassword} 
            passwordSuccess={passwordSuccess}
          />
        </div>
        <img
          className={classNames(
            isInputClicked
              ? ' hidden sm:flex w-[50%] sm:w-[330px] sm:mt-[30px] sm:mx-[30px] sm:order-first '
              : 'hidden',
          )}
          src={imageLoginResponsive}
          alt=""
        />
      <img className=' lg:hidden w-[50%] object-cover h-screen '  src={newImageLogin} alt='image Login' />

        {/* <ImageSignUp image={newImageLogin} /> */}
      </div>
    </div>
  )
}
export default MotDePassOublier
